/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Rating_LabelInputs */

const en_rating_label = /** @type {(inputs: Rating_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rating: ${i?.value} of 5`)
};

const de_rating_label = /** @type {(inputs: Rating_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bewertung: ${i?.value} von 5`)
};

/**
* | output |
* | --- |
* | "Rating: {value} of 5" |
*
* @param {Rating_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rating_label = /** @type {((inputs: Rating_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rating_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rating_label(inputs)
	return en_rating_label(inputs)
});